export default __webpack_public_path__ + "static/media/HR.2011cec2.jpg";